<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      pageConfig: {},
    };
  },
  computed: {},
  created() {
    var that = this;
    console.log(that.$route);
  },
  mounted() {
    var that = this;
    that.setConfig();
    that.testLanguage();

    $(document).ajaxComplete(function (event, xhr, settings) {
      if (that.$store.state.role == "user") {
        console.log("user");
        return;
      }

      if (!xhr) {
        return;
      }

      if (xhr.responseText.indexOf("{") < 0) {
        //如果不是json格式的数据 就不处理了
        return;
      }
      // console.log(event, xhr, settings,43424);
      var res = that.myfun.parseJson(xhr.responseText);

      if (res.code == 1 && res.msg.indexOf("登录") != -1) {
        console.log("登录过期");
        that.myfun.goName(that, "Login");
      }
    });
  },
  watch: {
    $route(to, from) {},
  },
  beforeCreate: function () {
    var that = this;
    if (that.$store.state.isLogin) {
      console.log('已经登录 token 持久化');
      $.ajaxSetup({
        headers: {
          Authorization: that.$store.state.token,
        },
      });
    }
  },
  methods: {
     testLanguage: function () {
      this.$i18n.locale = "zh";

      if (window.location.href.indexOf("?") > -1) {
        var theme = window.location.href.split("?")[1].split("&");

        var temp = {};

        theme.forEach(function (value, index) {
          var k = value.split("=")[0];
          var v = value.split("=")[1];

          temp[k] = v;
        });

        console.log("检测参数lang", temp);
        if (temp.hasOwnProperty("lang")) {
          this.$i18n.locale = temp.lang;
        }
      }

      
    },
    setConfig: function () {
      var that = this;
      that.pageConfig = {
        base_url: "https://laichatpanel.4ving.com",
        merchant_id: "190e35f7e0392953d43",
        // base_url: "https://103.214.175.95:8082",
      };

      that.$store.commit("setData", {
        key: "pageConfig",
        value: that.pageConfig,
      });

      that.$store.commit("setData", {
        key: "merchantSubView",
        value: "1",
      });
    },
    checkLogin: function () {
      var that = this;
      if (!that.$store.state.isLogin) {
        that.myfun.goName(that, "Login");
      }
    },
  },
  components: {},
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
}

:root {
  --vh: 1vh;
}

.hand {
  cursor: pointer;
}

.page_chat_user {
  .el-icon-position:before {
    background: orange;
    padding: 5px;
    border-radius: 3px;
    color: white;
  }

  .el-icon-picture-outline:before {
    background: orange;
    padding: 5px;
    border-radius: 3px;
    color: white;
  }
}

.page_chat_admin {
  .el-drawer {
    width: 80% !important;
    max-width: 400px !important;
  }

  .el-icon-position:before {
    background: orange;
    padding: 5px;
    border-radius: 3px;
    color: white;
  }

  .el-icon-picture-outline:before {
    background: orange;
    padding: 5px;
    border-radius: 3px;
    color: white;
  }
}

.page_start_chat_form {
  .nowrap {
    text-align: left;
    white-space: nowrap;
    td {
      padding: 5px;
      p {
        margin: 0;
      }
    }
  }
  .bootstrap-table {
    .myThead {
      background: #efefef;
      color: #999;
    }
    p.time {
      margin: 0;
      font-size: 14px;
      color: #333;
    }
    span.score {
      color: red;
      font-size: 18px;
    }
    tbody {
      color: #969696;
      tr:nth-of-type(odd) {
        background: #f6f4f5;
      }
    }
    th {
      border: none;
    }
    td {
      border: none;
    }
    .pagination-detail {
      display: none !important;
    }
  }
}

.page_chat_merchant {
  .el-collapse {
    border: none;
    .el-collapse-item__header {
      background: transparent;
      border: none;
      font-size: 20px;
      padding-left: 1em;
      color: #9ea2a8;
    }
    .el-collapse-item__wrap {
      border: none;
    }
    .el-collapse-item__content {
      background: transparent;
      font-size: 16px;
      padding-left: 2em;
      color: #9ea2a8;
      background: #2f343d;
    }
  }
}
</style>
